// import i18n from '@/language/i18n'
import auth from '@/middleware/auth'
import { PERMISSION_LEVELS } from '@/constants/permissions'

export default [
	{
		path: '/dashboard/:local_uid?/:conta_id?',
		name: 'Dashboard',
		icon: 'dashboard',
		meta: {
			title: 'Dashboard',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/Dashboard')
	},
	{
		path: '/dashboard-gerencial',
		name: 'DashboardGerencial',
		icon: 'dashboard',
		meta: {
			title: 'menu.dashboard_gerencial',
			permission: PERMISSION_LEVELS.MANAGER // Apenas Manager e Master
		},
		beforeEnter: auth,
		component: () => import('@/pages/DashboardGerencial')
	},
	{
		path: '/users/:page?/:id?',
		name: 'Users',
		icon: 'users',
		meta: {
			title: 'menu.users',
			permission: PERMISSION_LEVELS.MANAGER // Apenas Manager e Master
		},
		beforeEnter: auth,
		component: () => import('@/pages/Users')
	},
	{
		path: '/companies/:page?/:id?',
		name: 'Companies',
		icon: 'company',
		meta: {
			title: 'menu.companies',
			permission: PERMISSION_LEVELS.MASTER // Apenas Master
		},
		beforeEnter: auth,
		component: () => import('@/pages/Companies')
	},
	{
		path: '/locais',
		name: 'Locais',
		icon: 'rating',
		meta: {
			title: 'menu.locais',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/Locais')
	},
	{
		path: '/noticias-mercado',
		name: 'NoticiasMercado',
		icon: 'news',
		meta: {
			title: 'menu.noticias_mercado',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/NoticiasMercado')
	},
	{
		path: '/analysis',
		name: 'Analysis',
		icon: 'settings',
		meta: {
			title: 'menu.analysis',
			permission: PERMISSION_LEVELS.USER // Todos podem acessar
		},
		beforeEnter: auth,
		component: () => import('@/pages/Analysis')
	},
	{
		path: '/ia',
		name: 'IA',
		icon: 'settings',
		meta: {
			title: 'menu.ia',
			permission: PERMISSION_LEVELS.MASTER // Apenas Master
		},
		beforeEnter: auth,
		component: () => import('@/pages/Prompts')
	},
	// {
	// 	path: '/settings',
	// 	name: 'Settings',
	// 	icon: 'settings',
	// 	meta: {
	// 		title: 'menu.settings',
	// 		permission: PERMISSION_LEVELS.MASTER // Apenas Master
	// 	},
	// 	beforeEnter: auth,
	// 	component: () => import('@/pages/Settings')
	// }
	/* auto-gerado */
]
